<div class="wrap uk-margin-top">
    <div *ngIf="loading === true" class="uk-position-center">
        <div uk-spinner></div>
    </div>

    <div *ngIf="loading === false">
        <div class="uk-form-stacked uk-margin-large uk-grid-medium" uk-grid>
            <div class="uk-width-12-12 uk-margin-small-top" style="padding-left: 20px;">
                <div class="back-button" [routerLink]="[routerURL]">
                    <img src="../../../assets/icons/Back.svg" width="32px" height="32px" alt="back">
                    <span>{{previousUrlName}}</span>
                </div>
            </div>
            <div class="uk-width-12-12 uk-position-relative uk-margin-top">
                <div class="main-title bold">Réservation #{{ reservation.Code }}</div>
                <div class="button-main-title buttonMobile" *ngIf="sessionService.role.ability === 'super-admin'">
                    <button class="back-button regular" style="padding-right: 20px;"
                            [attr.disabled]="reservation.Status < 11 ? true : null"
                            [attr.uk-tooltip]="reservation.Status < 11 ? 'La réservation n\'est pas clôturée.' : null"
                            uk-toggle="target: #change-reservation-details"
                            type="button"
                            (click)="changeDetails.loadInformations()">
                        <span class="uk-visible@m uk-text-uppercase">Éditer les détails de la course</span>
                        <img src="../../../assets/icons/Edit.svg" width="32" height="32" alt="edit">
                    </button>
                    <button class="back-button regular" style="padding-right: 20px;" type="button"
                        uk-toggle="target: #choice-validation-delete-reservation">
                        <span class="uk-visible@m uk-text-uppercase">Supprimer la réservation</span>
                        <img src="../../../assets/icons/Close.svg" width="32px" height="32px" alt="back">
                    </button>
                </div>
            </div>
            <div class="uk-width-12-12 uk-margin-top" style="padding: 10px 20px;" [ngClass]="{
                'background-orange' : reservation.Status < 11 && reservation.Status >= 0,
                'background-cold-grey' : reservation.Status >= 11 && reservation.Status <= 14,
                'background-red' : reservation.Status == 20 || reservation.Status == -1
                }">
                <div class="title bold color-white" style="font-size: 15px; padding-left: 10px;">{{ sessionStatus }}
                </div>
            </div>
            <div uk-grid class="uk-width-12-12 padding-20 vop-background-white remove-grid-ml-pl"
                style="margin-top: 0px; padding-bottom: inherit;">
                <div class="uk-visible@s uk-width-4-12" style="min-height: 316.66px;">
                    <div class="img-wrap">
                        <img src="../../../../assets/icons/Booking.svg"
                            onerror="this.src='../../../../assets/icons/Infos.svg';this.className='img-error';">
                    </div>
                </div>
                <div class="uk-width-8-12 uk-grid-small" uk-grid>
                    <div class="uk-width-1-2@s">
                        <div class="uk-margin-left uk-margin-bottom">
                            <label class="label">Date de début</label>
                            <div class="uk-form-controls">
                                <span class="bold color-cold-grey"
                                    humanDateFormat="{{ reservation.ISODateStart }}"></span>
                            </div>
                        </div>
                        <div class="uk-margin-left uk-margin-bottom">
                            <label class="label">Date de fin</label>
                            <div class="uk-form-controls">
                                <span class="bold color-cold-grey"
                                    humanDateFormat="{{ reservation.ISODateEnd }}"></span>
                            </div>
                        </div>
                        <div *ngIf="reservation.Status >= 11 && reservation.demo === false"
                            class="uk-margin-left uk-margin-bottom">
                            <label class="label">Montant de la réservation</label>
                            <div class="uk-form-controls">
                                <span *ngIf="invoiceAvailable === true" class="bold color-cold-grey main-title"
                                    [class.color-red]="totalAmount <= 0">{{
                                    totalAmount.toFixed(2) }}€</span>
                                <span *ngIf="invoiceAvailable === false && invoiceLoading === false"
                                    class="bold color-cold-grey main-title">-</span>
                                <div uk-spinner *ngIf="invoiceLoading === true"></div>
                            </div>
                        </div>
                        <div *ngIf="sessionService.role.ability === 'super-admin' && reservation.demo === true && reservation.Status >= 11"
                            class="uk-margin-left uk-margin-bottom">
                            <label class="label color-dark-gray">Montant de la réservation</label>
                            <div class="uk-form-controls">
                                <span *ngIf="invoiceAvailable === true" class="bold color-dark-gray main-title">{{
                                    totalAmount.toFixed(2) }}€</span>
                                <span *ngIf="invoiceAvailable === false && invoiceLoading === false"
                                    class="bold color-cold-grey main-title">-</span>
                                <div uk-spinner *ngIf="invoiceLoading === true"></div>
                            </div>
                        </div>
                    </div>
                    <div class="uk-width-1-2">
                        <div class="uk-margin uk-margin-left">
                            <label class="label">Utilisateur</label>
                            <a class="uk-form-controls pointer uk-display-block"
                                [routerLink]="['/user/informations', reservation.IdAccount]"
                                [queryParams]="{from: '/reservation/informations/'+id, name: 'Réservation #'+reservation.Code }">
                                <span class="bold color-dark-turquoise">
                                    {{ reservation.User }}
                                </span>
                            </a>
                        </div>
                        <div class="uk-margin uk-margin-left">
                            <label class="label">Véhicule</label>
                            <a class="uk-form-controls pointer uk-display-block"
                                [routerLink]="['/ressource/vehicle/informations', reservation.IdVehicle]"
                                [queryParams]="{from: '/reservation/informations/'+id, name: 'Réservation #'+reservation.Code }">
                                <span class="bold color-dark-turquoise">
                                    {{ reservation.Vehicle }}
                                </span>
                            </a>
                        </div>
                        <div class="uk-margin uk-margin-left">
                            <label class="label">Logs technique</label>
                            <a class="uk-form-controls pointer uk-display-block"
                                [routerLink]="['/ressource/vehicle/logs', reservation.IdVehicle]"
                                [queryParams]="{start: reservation.ISODateStart, end: reservation.ISODateEnd}">
                                <span class="bold color-dark-turquoise">
                                    {{ reservation.Vehicle }}
                                </span>
                            </a>
                        </div>
                        <div *ngIf="reservation.demo === true" class="uk-margin">
                            <div class="uk-form-controls">
                                <button class="round-button bigger bold"
                                    style="cursor: default; padding: 10px 15px 10px 5px !important;">
                                    <img src="../../../../assets/icons/Warning.svg" height="32px" width="32px">
                                    <span class="uk-margin-small-left color-grey">Réservation staff</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="uk-width-12-12 padding-20 vop-background-white" style="margin-top: 0px;"
                *ngIf="reservation.Status < 11">
                <div class="title bold uk-margin-small-bottom">
                    Modifications
                </div>
                <div uk-grid class="remove-grid-ml-pl uk-form-stacked">
                    <div class="uk-width-1-1">
                        <div class="uk-margin">
                            <div class="uk-form-controls uk-margin-small-top">
                                <button type="button" uk-toggle="target: #change-reservation-period"
                                    class="button bold uk-display-inline-block uk-margin-small-left uk-margin-small-bottom">
                                    <span>Prolonger la réservation</span>
                                    <img src="../../../assets/icons/Add.svg" class="uk-margin-small-left" width="32px"
                                        height="32px" alt="back">
                                </button>
                                <button type="button" (click)="closeReservation()"
                                    class="button bold uk-display-inline-block uk-margin-small-left">
                                    <span>Clôturer la réservation</span>
                                    <img src="../../../assets/icons/Close.svg" class="uk-margin-small-left" width="32px"
                                        height="32px" alt="back">
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="uk-width-12-12 padding-20 vop-background-white" style="margin-top: 0px;"
                *ngIf="reservation.Status >= 11 ">
                <div class="title bold uk-margin-small-bottom">
                    Utilisation
                </div>
                <div uk-grid class="remove-grid-ml-pl uk-form-stacked">
                    <div class="uk-width-1-3@s uk-margin-small-left">
                        <div class="uk-margin">
                            <label class="label">Date de début réelle</label>
                            <div class="uk-form-controls uk-margin-small-top">
                                <span class="bold color-cold-grey"
                                    humanDateFormat="{{ reservation.ISORealDateStart }}"></span>
                                <span *ngIf="reservation.ISORealDateStart === ''"
                                    class="bold color-cold-grey">Indisponible</span>
                            </div>
                        </div>
                    </div>
                    <div class="uk-width-1-3@s uk-margin-small-left">
                        <div class="uk-margin">
                            <label class="label">Date de fin réelle</label>
                            <div class="uk-form-controls uk-margin-small-top">
                                <span class="bold color-cold-grey"
                                    humanDateFormat="{{ reservation.ISORealDateEnd }}"></span>
                                <span *ngIf="reservation.ISORealDateEnd === ''"
                                    class="bold color-cold-grey">Indisponible</span>
                            </div>
                        </div>
                    </div>
                    <div class="uk-width-1-3@s uk-margin-small-left">
                        <div class="uk-margin">
                            <label class="label">Kilomètres</label>
                            <div class="uk-form-controls uk-margin-small-top">
                                <span class="bold color-cold-grey"
                                    [class.color-red]="reservation.DistanceTraveled < 0">{{ reservation.DistanceTraveled
                                    }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <!-- Parti commentaire pas encore integré -->

            <!-- <div class="uk-width-12-12 padding-20 vop-background-white" style="margin-top: 0px;">
                <div class="title bold uk-margin-small-bottom">
                    Commentaire
                </div>
                <div uk-grid class="remove-grid-ml-pl uk-form-stacked">
                    <div class="uk-width-1-1">
                        <div class="uk-margin">
                            <div class="uk-form-controls uk-margin-small-top">
                                <textarea class="uk-textarea" rows="5" placeholder="Commentaire" disabled="true"
                                    style="resize: none; height: auto" [(ngModel)]="reservation.Commentaire"></textarea>
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->

            <!-- Parti commentaire pas encore integré -->

            <div class="uk-width-12-12 padding-20 vop-background-white" style="margin-top: 0px;"
                *ngIf="reservation.Status >= 11">
                <div class="uk-width-12-12 separator-horizontal uk-margin-bottom"></div>
                <div class="title bold uk-margin-small-bottom">
                    Facturation
                </div>
                <div uk-grid class="remove-grid-ml-pl uk-form-stacked">
                    <div class="uk-width-1-1">
                        <div class="uk-margin">
                            <div class="uk-form-controls uk-margin-small-top">
                                <button [disabled]="reservation.Status < 11"
                                    class="button bold uk-display-inline-block uk-margin-small-left uk-margin-small-bottom"
                                    (click)="downloadInvoice()">
                                    <span>Télécharger la facture</span>
                                    <img src="../../../assets/icons/Export.svg" class="uk-margin-small-left"
                                        width="32px" height="32px" alt="back">
                                </button>
                                <button
                                    [disabled]="(invoiceAvailable === false ? true : false) || (reservation.Status > 12 ? true : false)"
                                    class="button bold uk-display-inline-block uk-margin-small-left uk-margin-small-bottom"
                                    uk-toggle="target: #change-reservation-amounts">
                                    <!-- (click)="refreshInvoice()" -->
                                    <span>Éditer la facture</span>
                                    <img src="../../../assets/icons/Edit.svg" class="uk-margin-small-left" width="32px"
                                        height="32px" alt="back">
                                </button>
                                <button [disabled]="reservation.Status != 12 ? true : false"
                                    class=" button bold uk-display-inline-block uk-margin-small-left"
                                    uk-toggle="target: #choice-validation-confirm-payment">
                                    <span>Confirmer le paiement</span>
                                    <img src="../../../assets/icons/OK.svg" class="uk-margin-small-left" width="32px"
                                        height="32px" alt="back">
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="uk-width-12-12 padding-20" *ngIf="reservation.StatesOfCars.length > 0">
                <div class="title bold uk-margin-medium-bottom">
                    <span>États des lieux et sinistres</span>
                </div>
                <div class="uk-width-12-12" style="width: calc(100% + 20px); max-width: calc(100% + 20px);">
                    <div *ngIf='entryStates.statesOfCar[0]' uk-grid
                        class="uk-width-1-1 item-list light color-grey remove-grid-ml-pl" style="height: 124px;">
                        <div class="uk-width-2-12 item-column img-wrap" style="background: #eaeaea;">
                            <div uk-lightbox>
                                <a class="uk-button uk-button-default" [href]="entryStates.statesOfCar[0].imgs[0]">
                                    <img class="uk-position-absolute" [src]="entryStates.statesOfCar[0].imgs[0]"
                                        alt="adherent"
                                        onerror="this.src='../../../../assets/img/no-photo.png';this.className='img-error';" />
                                </a>
                            </div>
                        </div>
                        <div class="uk-width-10-12 item-column remove-grid-ml-pl" uk-grid
                            style="padding-left: 20px !important; padding-right: 20px !important;">
                            <div class="uk-width-4-12 item-column bold border" style="font-size: 15px;">
                                <span class="title">États des lieux de sortie</span>
                            </div>
                            <div class="uk-width-2-12 item-column regular border" style="font-size: 15px;"
                                *ngIf="entryStates.exists === true">
                                <span humanDateFormat="{{ entryStates.statesOfCar[0].ISOCreated }}" noDay="true"
                                    shortened="true"></span>
                            </div>
                            <div class="uk-width-2-12 item-column regular border" style="font-size: 15px;"
                                *ngIf="entryStates.exists === true">
                                <span hours="{{ entryStates.statesOfCar[0].ISOCreated }}"></span>
                            </div>
                            <div class="uk-width-2-12 item-column regular border" style="font-size: 15px;"
                                *ngIf="entryStates.exists === true">
                                <div>
                                    <span class="material-icons vertical-align-middle"
                                        [class.color-green]="entryStates.statesOfCar[0].state === 0"
                                        [class.color-orange]="entryStates.statesOfCar[0].state === 1">fiber_manual_record</span>
                                    <span *ngIf="entryStates.statesOfCar[0].state === 0"
                                        class="title bold vertical-align-middle uk-margin-small-left">Nouveau</span>
                                    <span *ngIf="entryStates.statesOfCar[0].state === 1"
                                        class="title bold vertical-align-middle uk-margin-small-left">À traîter</span>
                                    <span *ngIf="entryStates.statesOfCar[0].state === 2"
                                        class="title bold vertical-align-middle uk-margin-small-left">Archivé</span>
                                </div>
                            </div>
                            <div class="uk-width-2-12 item-column border" *ngIf="entryStates.exists === true">
                                <button class="back-button uk-text-right" uk-toggle="target: #state-of-car-management"
                                    (click)="bindStates(entryStates)">
                                    <img src="../../../assets/icons/Edit.svg" width="32px" height="32px" alt="edit" />
                                </button>
                            </div>
                            <div class="uk-width-8-12 item-column uk-text-right regular border"
                                *ngIf="entryStates.exists === false">
                                <span class="title">Aucune donnée</span>
                            </div>
                        </div>
                    </div>
                    <div *ngIf='variousStates.statesOfCar[0]' uk-grid
                        class="uk-width-1-1 item-list light color-grey remove-grid-ml-pl" style="height: 124px;">
                        <div class="uk-width-2-12 item-column img-wrap" style="background: #eaeaea;">
                            <div uk-lightbox>
                                <a class="uk-button uk-button-default" [href]="variousStates.statesOfCar[0].imgs[0]">
                                    <img class="uk-position-absolute" [src]="variousStates.statesOfCar[0].imgs[0]"
                                        alt="adherent"
                                        onerror="this.src='../../../../assets/img/no-photo.png';this.className='img-error';" />
                                </a>
                            </div>
                        </div>
                        <div class="uk-width-10-12 item-column remove-grid-ml-pl" uk-grid
                            style="padding-left: 20px !important; padding-right: 20px !important;">
                            <div class="uk-width-4-12 item-column bold border" style="font-size: 15px;">
                                <span class="title">Sinistres & États des lieux</span>
                            </div>
                            <div class="uk-width-2-12 item-column regular border" style="font-size: 15px;"
                                *ngIf="variousStates.exists === true">
                                <span humanDateFormat="{{ variousStates.statesOfCar[0].ISOCreated }}" noDay="true"
                                    shortened="true"></span>
                            </div>
                            <div class="uk-width-2-12 item-column regular border" style="font-size: 15px;"
                                *ngIf="variousStates.exists === true">
                                <span hours="{{ variousStates.statesOfCar[0].ISOCreated }}"></span>
                            </div>
                            <div class="uk-width-2-12 item-column regular border" style="font-size: 15px;"
                                *ngIf="variousStates.exists === true">
                                <div>
                                    <span class="material-icons vertical-align-middle"
                                        [class.color-green]="variousStates.statesOfCar[0].state === 0"
                                        [class.color-orange]="variousStates.statesOfCar[0].state === 1">fiber_manual_record</span>
                                    <span *ngIf="variousStates.statesOfCar[0].state === 0"
                                        class="title bold vertical-align-middle uk-margin-small-left">Nouveau</span>
                                    <span *ngIf="variousStates.statesOfCar[0].state === 1"
                                        class="title bold vertical-align-middle uk-margin-small-left">À traîter</span>
                                    <span *ngIf="variousStates.statesOfCar[0].state === 2"
                                        class="title bold vertical-align-middle uk-margin-small-left">Archivé</span>
                                </div>
                            </div>
                            <div class="uk-width-2-12 item-column border" *ngIf="variousStates.exists === true">
                                <button class="back-button uk-text-right" uk-toggle="target: #state-of-car-management"
                                    (click)="bindStates(variousStates)">
                                    <img src="../../../assets/icons/Edit.svg" width="32px" height="32px" alt="edit" />
                                </button>
                            </div>
                            <div class="uk-width-8-12 item-column uk-text-right regular border"
                                *ngIf="variousStates.exists === false">
                                <span class="title">Aucune donnée</span>
                            </div>
                        </div>
                    </div>
                    <div *ngIf='exitStates.statesOfCar[0]' uk-grid
                        class="uk-width-1-1 item-list light color-grey remove-grid-ml-pl" style="height: 124px;">
                        <div class="uk-width-2-12 item-column img-wrap" style="background: #eaeaea;">
                            <div uk-lightbox>
                                <a class="uk-button uk-button-default" [href]="exitStates.statesOfCar[0].imgs[0]">
                                    <img class="uk-position-absolute" [src]="exitStates.statesOfCar[0].imgs[0]"
                                        alt="adherent"
                                        onerror="this.src='../../../../assets/img/no-photo.png';this.className='img-error';" />
                                </a>
                            </div>
                        </div>
                        <div class="uk-width-10-12 item-column remove-grid-ml-pl" uk-grid
                            style="padding-left: 20px !important; padding-right: 20px !important;">
                            <div class="uk-width-4-12 item-column bold border" style="font-size: 15px;">
                                <span class="title">États des lieux d'entrée</span>
                            </div>
                            <div class="uk-width-2-12 item-column regular border" style="font-size: 15px;"
                                *ngIf="exitStates.exists === true">
                                <span humanDateFormat="{{ exitStates.statesOfCar[0].ISOCreated }}" noDay="true"
                                    shortened="true"></span>
                            </div>
                            <div class="uk-width-2-12 item-column regular border" style="font-size: 15px;"
                                *ngIf="exitStates.exists === true">
                                <span hours="{{ exitStates.statesOfCar[0].ISOCreated }}"></span>
                            </div>
                            <div class="uk-width-2-12 item-column regular border" style="font-size: 15px;"
                                *ngIf="exitStates.exists === true">
                                <div>
                                    <span class="material-icons vertical-align-middle"
                                        [class.color-green]="exitStates.statesOfCar[0].state === 0"
                                        [class.color-orange]="exitStates.statesOfCar[0].state === 1">fiber_manual_record</span>
                                    <span *ngIf="exitStates.statesOfCar[0].state === 0"
                                        class="title bold vertical-align-middle uk-margin-small-left">Nouveau</span>
                                    <span *ngIf="exitStates.statesOfCar[0].state === 1"
                                        class="title bold vertical-align-middle uk-margin-small-left">À traîter</span>
                                    <span *ngIf="exitStates.statesOfCar[0].state === 2"
                                        class="title bold vertical-align-middle uk-margin-small-left">Archivé</span>
                                </div>
                            </div>
                            <div class="uk-width-2-12 item-column border" *ngIf="exitStates.exists === true">
                                <button class="back-button uk-text-right" uk-toggle="target: #state-of-car-management"
                                    (click)="bindStates(exitStates)">
                                    <img src="../../../assets/icons/Edit.svg" width="32px" height="32px" alt="edit" />
                                </button>
                            </div>
                            <div class="uk-width-8-12 item-column uk-text-right regular border"
                                *ngIf="exitStates.exists === false">
                                <span class="title">Aucune donnée</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="uk-width-12-12 padding-20" *ngIf="events.length > 0">
                <div class="title bold uk-margin-medium-bottom">
                    <span>Historique des statuts de la réservation</span>
                </div>
                <div class="uk-width-12-12" style="width: calc(100% + 20px); max-width: calc(100% + 20px);">
                    <div uk-grid *ngFor="let event of events; let i = index"
                        class="uk-width-1-1 item-list light color-grey remove-grid-ml-pl" style="height: 60px;">
                        <div class="uk-width-8-12 item-column bold border" style="font-size: 15px;">
                            <div>
                                <span class="material-icons vertical-align-middle uk-display-inline"
                                    [class.color-cold-grey]="event.type >= 11"
                                    [class.color-orange]="event.type < 11">fiber_manual_record</span>
                                <span class="title uk-display-inline vertical-align-middle uk-margin-small-left"
                                    style="font-size: 15px;">{{ event.sessionStatus }}</span>
                            </div>
                        </div>
                        <div class="uk-width-2-12 item-column regular border" style="font-size: 15px;">
                            <span class="uk-text-center" humanDateFormat="{{ event.ISOInsertDate }}" noDay="true"
                                shortened="true"></span>
                        </div>
                        <div class="uk-width-2-12 item-column regular border" style="font-size: 15px;">
                            <span class="uk-text-center" hours="{{ event.ISOInsertDate }}"></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<app-change-reservation-amounts [id]="id" [reservation]="reservation" (changed)="waitInvoice();">
</app-change-reservation-amounts>

<app-change-reservation-details *ngIf="sessionService.role.ability === 'super-admin'" [id]="id"
    [reservation]="reservation" (changed)="waitInvoice();" #changeDetails></app-change-reservation-details>

<app-change-reservation-period [id]="id" [reservation]="reservation" (changed)="loadInformations()">
</app-change-reservation-period>

<app-states-of-car-management [statesOfCar]="boundStates.statesOfCar" (changed)="loadInformations()">
</app-states-of-car-management>

<app-choice-validation [name]="'delete-reservation'" (changed)="($event === true) ? deleteReservation() : false;">
</app-choice-validation>

<app-choice-validation [name]="'confirm-payment'" (changed)="($event === true) ? changeStatus(13) : false;">
</app-choice-validation>